module.exports = __webpack_public_path__ + "img/residencial_santafe.42754dd2.jpg";